import { SvgProps } from "components/icons/types";

export const InkleAiAvatar = (props: SvgProps) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#inkle_ai_avatar_clip)">
        <rect width="40" height="40" rx="20" fill="#5622FF" />
        <g filter="url(#inkle_ai_avatar_f0)">
          <circle
            cx="20.0635"
            cy="20.0136"
            r="20"
            fill="url(#inkle_ai_avatar_g0)"
          />
        </g>
        <g filter="url(#inkle_ai_avatar_f1)">
          <path
            d="M2.6238 19.2903C-1.81128 17.2147 -4.94098 23.5551 -4.34017 25.2847C-4.17632 26.673 5.46944 36.2332 9.31463 40.5918C16.3605 47.0368 21.208 41.5658 24.3759 40.5918C26.5788 39.8043 31.3589 37.6751 32.8555 35.4576C34.7262 32.6856 38.4676 24.3835 30.9848 23.81C23.502 23.2365 23.3245 26.9916 17.3846 27.9611C11.4448 28.9305 8.16766 21.8847 2.6238 19.2903Z"
            fill="#EA638C"
          />
        </g>
        <g filter="url(#inkle_ai_avatar_f2)">
          <path
            d="M27.6382 -13.8974C30.7909 -17.6442 25.4766 -22.3083 23.6504 -22.1756C22.2671 -22.3766 10.5361 -15.5339 5.33084 -12.9478C-2.71824 -7.81014 1.31177 -1.71187 1.4327 1.6002C1.62313 3.93191 2.44264 9.10022 4.19728 11.1197C6.39058 13.6441 13.4415 19.4068 15.9321 12.3274C18.4228 5.24795 14.8416 4.10461 15.4425 -1.88376C16.0434 -7.87213 23.6974 -9.21397 27.6382 -13.8974Z"
            fill="#9A7AFF"
          />
        </g>
        <g>
          <mask
            id="inkle_ai_avatar_mask"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="15"
            y="19"
            width="34"
            height="34"
          >
            <path
              d="M29.192 36.9497C31.1098 35.6077 38.9825 30.5729 40.9898 19.4169C52.9651 20.5229 48.5257 48.2051 44.0758 51.5193C39.6258 54.8336 18.2136 48.2695 15.6191 45.2518C18.5276 44.965 24.0988 40.5136 29.192 36.9497Z"
              fill="#3A17AD"
            />
          </mask>
          <g mask="url(#inkle_ai_avatar_mask)">
            <circle cx="19.999" cy="20.0001" r="20" fill="#3A17AD" />
          </g>
        </g>
        <g>
          <path
            d="M28.3051 18.2438C23.5142 16.4693 20.1586 13.7177 18.5502 7.67835C16.6867 13.5632 14.1102 15.9467 8.49232 17.8826C13.3743 19.1754 16.443 22.1224 18.1948 28.0641C19.2359 21.8997 22.5369 19.6526 28.3051 18.2438Z"
            fill="white"
          />
          <path
            d="M32.5244 28.0729C30.2956 27.4116 28.6892 26.2633 27.7776 23.5693C27.1081 26.2979 26.0096 27.4579 23.5168 28.5065C25.7725 28.9463 27.2544 30.192 28.2283 32.8373C28.5159 30.0066 29.9474 28.8866 32.5244 28.0729Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="inkle_ai_avatar_f0"
          x="-0.0539549"
          y="-0.103851"
          width="40.2349"
          height="40.2349"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.99900001287460327 0.99900001287460327"
            numOctaves="3"
            seed="4328"
          />
          <feDisplacementMap
            in="shape"
            scale="0.23486293852329254"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="inkle_ai_avatar_f1"
          x="-15.3379"
          y="7.95371"
          width="61.7231"
          height="46.6554"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5.46193"
            result="effect1_foregroundBlur"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.99900001287460327 0.99900001287460327"
            numOctaves="3"
            seed="2100"
          />
          <feDisplacementMap
            in="effect1_foregroundBlur"
            scale="0.21847710013389587"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect2_texture">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="inkle_ai_avatar_f2"
          x="-10.606"
          y="-33.1038"
          width="50.1468"
          height="59.7588"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5.46193"
            result="effect1_foregroundBlur"
          />
        </filter>
        <linearGradient
          id="inkle_ai_avatar_g0"
          x1="36.0876"
          y1="20.0136"
          x2="-31.0209"
          y2="10.7064"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2A1BA" />
          <stop offset="0.362617" stopColor="#F2A1BA" stopOpacity="0" />
        </linearGradient>
        <clipPath id="inkle_ai_avatar_clip">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
